import { createSlice } from "@reduxjs/toolkit";

const stepSlice = createSlice({
  name: "step",
  initialState: {
    data: [],
    NodeElements:[],
  },
  reducers: {
    editStep(state: any, action) {
      return {
        ...state,
        data: state.data.map((step) =>
          step.id === action.payload.element
            ? { ...step, step: action.payload.step }
            : step
        ),
      };
    },
    addStep(state: any, action) {
      const { element } = action.payload;
      state.data = [...state.data, element];
      let stateId = state.data.length;
      state.lastStep = stateId++;
    },
    deleteStep(state, action) {},
    getAllSteps(state, action) {},
    setSteps(state, action) {
      return {
        ...state,
        data: action.payload,
        lastStep: action.payload.length,
      };
    },
    saveSteps(state, action) {},
    nextStep(state, action) {},
    prevStep(state, action) {},
    startStep(state, action) {},
    endStep(state, action) {},
    lastStep(state: any, action) {
      let stateId = state.data.length;
      let newId = stateId++;
      return { ...state, lastStep: newId };
    },
    currentStep(state, action) {
      return { ...state, currentStep: action.payload };
    },
    getStep(state, action) {},
    setNodeElements(state, action) {
      state.NodeElements = action.payload;
    },
  },
});

export const {
  addStep,
  editStep,
  deleteStep,
  getAllSteps,
  setSteps,
  saveSteps,
  nextStep,
  prevStep,
  startStep,
  endStep,
  currentStep,
  lastStep,
  setNodeElements,
} = stepSlice.actions;

export default stepSlice.reducer;
